import PropTypes from 'prop-types';
import React from 'react';
import FilterEditorStep from './FilterEditorStep';
import ValueInput from './ValueInput';
import {FormattedMessage} from 'react-intl';
import {insecureHash} from 'utilities/hash';

const ValueStep = ({
  cardId,
  column,
  dataSourceId,
  onClick,
  onValuesChange,
  pageId,
  selected,
  values,
}) => (
  <FilterEditorStep selected={selected} onClick={onClick}>
    <label className="FilterEditor__StepTitle" htmlFor={insecureHash(`${cardId}${dataSourceId}`)}>
      <FormattedMessage
        id="ValueStep__Title"
        description="Label for value step of filter editor"
        defaultMessage="Value"
      />
    </label>
    <div className="FilterEditor__StepValue">
      <ValueInput
        cardId={cardId}
        column={column}
        dataSourceId={dataSourceId}
        onInputChange={onValuesChange}
        pageId={pageId}
        selected={selected}
        values={values}
        id={insecureHash(`${cardId}${dataSourceId}`)}
      />
    </div>
  </FilterEditorStep>
);

ValueStep.propTypes = {
  cardId: PropTypes.string,
  column: PropTypes.object,
  dataSourceId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onValuesChange: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
};

export default ValueStep;
